module.exports = __webpack_public_path__ + "7393d54f4feab6faf8c8737edf6b47c7.glb";